import { useState, useEffect } from 'react';
import { getUserSessionRegions, RegionsByZipCode } from './regionalInfoHelpers';

/**
 * Used to read regions from sessionStorage only after hydration step has finished.
 */
export function useUserSessionRegions(): RegionsByZipCode[] | undefined {
    const [regions, setRegions] = useState<RegionsByZipCode[] | undefined>(undefined);

    /**
     * `getUserSessionsRegions` always returns a new instance of `userRegions`, so we
     * try to always return the same reference when the contents of the object didn't
     * change, making it easier to use this hooks with the likes of useEffect or useMemo
     */
    const userRegionsString = JSON.stringify(getUserSessionRegions());

    useEffect(() => {
        const userRegions = getUserSessionRegions();
        setRegions(userRegions);
    }, [userRegionsString]);

    return regions;
}
